import React, { useState, useEffect } from 'react';
import { Container, Typography, IconButton } from "@mui/material";
import "./AddressDetail.css";
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import BoxDetail from './components/BoxDetail';
import alerta from "../../images/alerta.png";
import IconArrow from "../../images/ICON_ARROW.png";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MessageAddress from './components/MessageAddress/MessageAddress';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useSection } from '../../context/SectionContext';
import { useDatosUser } from "../../context/userContext";
import { useNavigate } from "react-router-dom";
import useRedirectIframe from "../../hooks/useRedirectIframe";
import { URLS } from "../../context/urls";
import { ADDRESS_DETAIL_TEXTS } from './addressDetailTexts';
import { useShippingAddresses } from '../../hooks/useShippingAddresses';

const AddressDetail = () => {
    const navigate = useNavigate();
    const { nombreCompleto, completed, wuujuID, phone } = useDatosUser();
    

    useRedirectIframe(URLS.REDIRECT_IFRAME);
    useEffect(() => {
        if (completed === false || completed === null) {
            navigate('/crear-casillero-2');
        }
    }, [completed, navigate]); 

    const { optionalVariable, changeSection } = useSection();
    const { options, loading, error } = useShippingAddresses(wuujuID);

    const findIndexByName = (name) => {
        return options.findIndex(item => item.name === name);
    };

    const [selectedOptionIndex, setSelectedOptionIndex] = useState(-1);

    useEffect(() => {
        if (options && options.length > 0) {
            const index = findIndexByName(optionalVariable);
            setSelectedOptionIndex(index >= 0 ? index : 0);
        }
    }, [options, optionalVariable]);

    const handleNextClick = () => {
        setSelectedOptionIndex((prevIndex) => (prevIndex + 1) % options.length);
    };

    const handlePrevClick = () => {
        setSelectedOptionIndex((prevIndex) => (prevIndex - 1 + options.length) % options.length);
    };

    if (loading || !options || options.length === 0 || selectedOptionIndex < 0 || !options[selectedOptionIndex]) {
        return (
            <Container maxWidth="xl" className="address-main" sx={{ paddingTop: "2vw" }}>
                <Typography sx={{ fontFamily: 'Viga', fontSize: { xs: '5vw', sm: '2vw' } }}>
                    Cargando direcciones...
                </Typography>
            </Container>
        );
    }

    const selected = options[selectedOptionIndex];
    console.log(options[selectedOptionIndex]);

    return (
        <>
            <IconButton
                aria-label="close"
                onClick={() => changeSection('direcciones')}
                style={{ position: 'absolute', left: '1vw', top: '0.2vw' }}
            >
                <ArrowBackIcon sx={{
                    color: "#5452ff",
                    fontSize: { xs: '5vw', sm: '1vw', md: '1vw', lg: '1.5vw', xl: '2vw' },
                    p: "1px",
                }} /> <span className='boton-regresar' style={{ paddingLeft: '0.5vw', fontFamily: 'Viga' }}>Regresar</span>
            </IconButton>
            <Container maxWidth="xl" className='address-main' sx={{ paddingTop: "2vw" }}>
                <h1 className='title-direccion'>{ADDRESS_DETAIL_TEXTS.MAIN_TITLE} <span className="break-title"></span></h1>
                <div className='compra-variable-container'>
                    <img
                        src={IconArrow}
                        alt="Anterior"
                        onClick={handlePrevClick}
                        className='custom-button1'
                    />
                    <div className='compra-variable' style={{ backgroundColor: selected.color }}>
                        {selected.icon}
                        <span>{selected.text}</span>
                    </div>
                    <img
                        src={IconArrow}
                        alt="Siguiente"
                        onClick={handleNextClick}
                        className='custom-button2'
                    />
                </div>

                <p className='general-text'> <img src={alerta} alt="" className='img-alert2' /> {ADDRESS_DETAIL_TEXTS.TERMS_CONDITIONS_TEXT}
                    <a href={URLS.VIRTUAL_LOCKER_INSTRUCTIONS} rel="noreferrer" target="_blank" className='terminos-text'>{ADDRESS_DETAIL_TEXTS.TERMS_CONDITIONS_TEXT2} </a></p>

                <BoxDetail
                    label="Nombre"
                    variable={nombreCompleto}
                    icon={<PermIdentityOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={selected.color}
                />
                <BoxDetail
                    label="Apellido"
                    variable={selected.apellido}
                    icon={<PermIdentityOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={selected.color}
                />
                <BoxDetail
                    label="Dirección"
                    variable={selected.variable?.Direccion}
                    icon={<PlaceOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={selected.color}
                />
                {selected.variable?.Apto && (
                    <BoxDetail
                        label="Apto"
                        variable={selected.variable.Apto}
                        icon={<PlaceOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                        color={selected.color}
                    />
                )}
                <BoxDetail
                    label="Estado"
                    variable={selected.variable?.Estado}
                    icon={<PlaceOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={selected.color}
                />
                <BoxDetail
                    label="Ciudad"
                    variable={selected.variable?.Ciudad}
                    icon={<PlaceOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={selected.color}
                />
                <BoxDetail
                    label={<>Código <br /> Postal</>}
                    variable={selected.variable?.CodigoPostal}
                    icon={<PlaceOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={selected.color}
                />
                <BoxDetail
                    label="Teléfono"
                    variable={selected.variable?.Telefono || phone}
                    icon={<PhoneOutlinedIcon sx={{ fontSize: { xs: '4vw', sm: '1.3vw' } }} />}
                    color={selected.color}
                />
                <MessageAddress
                    height={options[selectedOptionIndex]?.messageHeight}
                    text={options[selectedOptionIndex]?.lateralMessage}
                />
                <div className='typography-content-1'>
                    <Typography
                        sx={{
                            color: 'gray',
                            fontFamily: 'Viga, sans-serif',
                            fontSize: { xs: '3vw', sm: '1vw' },
                            position: 'relative',
                            zIndex: 1,
                        }}
                    >
                        {ADDRESS_DETAIL_TEXTS.DOUBTS_TEXT}
                        <span className='whatsapp-icon-container-1'>
                            <WhatsAppIcon className="whatsapp-icon-1"
                                sx={{
                                    color: "#5452ff",
                                    fontSize: { xs: '3vw', sm: '0.9vw' }
                                }} />
                        </span>
                        <a
                            href={URLS.CONTACT_US}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="whatsapp-link-1"
                        >
                            {ADDRESS_DETAIL_TEXTS.CONTACT_US_TEXT}
                        </a>
                        ───
                    </Typography>
                </div>
            </Container>
        </>
    );
}

export default AddressDetail;
